module.exports = __webpack_public_path__ + "media/images/icons/dropdown-arrow-0150bba097a45969e32defd97e4194a9.svg";